<template>
  <div class="source">
    <div
      class="demo-table"
      v-if="goodsTable.contentList.length"
    >
      <table
        class="table"
        border="0"
        align="center"
        cellpadding="0"
        cellspacing="0"
      >
        <colgroup>
          <col
            v-for="(item,index) in goodsTable.headerList"
            :key="index"
            :style="{width: item.colWidth}"
          >
        </colgroup>
        <tbody>
          <tr>
            <th
              colspan="1"
              rowspan="1"
              v-for="(item,index) in goodsTable.headerList"
              :key="index"
            >{{item.title}}</th>
          </tr>
          <tr
            v-for="(item, index) in goodsTable.contentList"
            :key="index"
          >
            <td>{{index + 1}}</td>
            <td>{{item.actType == 2 ? "【爆款】" : item.actType == 3 ? "【拼单】" : ""}}{{item.pname || item.productName}}</td>
            <td>
              <div>
                <span
                  v-for="(data,index) in item.normList"
                  :key="index"
                >{{item.normList.length == index + 1 ? data.attr : data.attr  + "/"}}</span>
                <span v-if="!item.normList.length">/</span>
              </div>
            </td>
            <td>{{item.count}}</td>
            <td>{{item.totalSupplyPrice || item.supplyPrice}}</td>
            <td v-if="type != 0">{{item.count}}</td>
            <td v-if="type != 0">{{item.remark}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div
      class="demo-table"
      style="margin-top: 0.4rem"
      v-if="schoolTable.contentList.length"
    >
      <table
        class="table"
        border="0"
        align="center"
        cellpadding="0"
        cellspacing="0"
      >
        <colgroup>
          <col
            v-for="(item,index) in schoolTable.headerList"
            :key="index"
            :style="{width: item.colWidth}"
          >
        </colgroup>
        <tbody>
          <tr>
            <th
              colspan="1"
              rowspan="1"
              v-for="(item,index) in schoolTable.headerList"
              :key="index"
            >{{item.title}}</th>
          </tr>
          <template v-for="item in schoolTable.contentList">
            <tr
              v-for="(goods, index) in item.products"
              :key="index"
            >
              <td
                :rowspan="item.products.length"
                v-if="index==0"
              >{{item.index + 1}}</td>
              <td
                :rowspan="item.products.length"
                v-if="index==0"
              >{{item.csName}}</td>
              <td style="text-align: left">
                <p>{{goods.productName}}</p>
                <p>
                  <span
                    v-for="(data,dataIndex) in goods.normList"
                    :key="dataIndex"
                  >{{goods.normList.length == dataIndex + 1 ? data.attr : data.attr + "/"}}</span>
                </p>
              </td>
              <td>{{goods.count}}</td>
              <td>{{goods.remark}}</td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: String,
    goodsTable: Object,
    schoolTable: Object,
  }
}
</script>

<style lang="scss" scoped>
.source {
  padding-top: 15px;
  background-color: #ffffff;
  white-space: nowrap;
  overflow-x: auto;
  .demo-table {
    width: fit-content;
    padding: 0 10px;
    .table {
      width: max-content;
      font-size: 13px;
      text-align: center;
      border-top: 1px solid #1d1d1d;
      border-left: 1px solid #1d1d1d;
      th,
      td {
        padding: 4px;
        border-right: 1px solid #1d1d1d;
        border-bottom: 1px solid #1d1d1d;
        box-sizing: border-box;
        white-space: normal;
      }
      colgroup {
        col {
          &:nth-child(1) {
            width: 36px;
          }
        }
      }
    }
  }
}
</style>